import { render, staticRenderFns } from "./ModalRemoveSharedFields.vue?vue&type=template&id=11be1ec9&lang=html&"
import script from "./ModalRemoveSharedFields.vue?vue&type=script&lang=js&"
export * from "./ModalRemoveSharedFields.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports